import _ from "underscore";
import BaseControl from "./../base-control";

export default function() {
    var View = BaseControl.View.extend({
        hideLabel: true,
        template: _.template("<div ></div>"),
        className: "line-break",
        getViewValue: function() {},

        setViewValue: function() {},

        onShow: function() {}
    });

    return _.extend({}, BaseControl, {
        View: View
    });
}
